import { StateMachineType } from "libs/statemachine"
import baseReducer from "store/utilities/baseReducer"
import ActionType from "store/executer/ActionType"

export interface IExecuterState {
  readonly data: { [key: string]: any | null };
  readonly viewState: { [key: string]: StateMachineType };
}

const initialState: IExecuterState = {
  data: {},
  viewState: {},
}

const executerReducer = baseReducer(initialState, {
  [ActionType.EXECUTER_DATA](
    state,
    action,
  ) {
    return {
      ...state,
      data: {
        ...state.data,
        [action.payload.feature]: action.payload.data
      },
    }
  },
  [ActionType.EXECUTER_VIEW_STATE](
    state,
    action,
  ) {
    return {
      ...state,
      viewState: {
        ...state.viewState,
        [action.payload.feature]: action.payload.viewState,
      },
    }
  },
})

export default executerReducer